module.exports = __webpack_public_path__ + "static/img/200028.a91e4c43.png";